<template>
  <div>
    <div class="newsList oa-layout-content">
      <a-tabs v-model="tabnum" @change="tabClick">
        <a-tab-pane key="0" tab="业务申请" />
        <a-tab-pane key="2" tab="已办结" />
        <a-tab-pane key="1" tab="未办结" />
      </a-tabs>
      <div
        class="my-mission-item"
        v-for="(need, index) in ToDoTasksData"
        :key="index"
      >
        <div class="my-mission-tips">{{ need.processName }}</div>
        <!-- <div class="my-mission-title ml20">[项目申请申请]</div> -->
        <div>{{ need.createdDate }}</div>
        <!-- 暂无更多数据 -->
      </div>
      <a-empty v-show="ToDoTasksData.length === 0 ? true : false" />
      <!-- 分页 -->
      <div class="wordbrnch-pageination mt20">
        <a-pagination
          :current="page"
          :default-current="page"
          :total="total"
          :pageSize="size"
          @change="pageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { getAllProcess } from '@/views/workbench/api/api'
export default {
  data() {
    return {
      tabnum: '0', // 0业务申请， 1已办结， 2未办结
      ToDoTasksData: [],
      total: 0,
      page: 1,
      size: 10
    }
  },
  created() {
    this.tabnum = this.$route.query.flag
    this.load()
  },
  methods: {
    load() {
      let params = {}
      params.flag = this.tabnum
      params.page = this.page
      params.size = this.size
      getAllProcess(params).then((res) => {
        if (res.data.code == 0) {
          this.ToDoTasksData = res.data.data
          this.total = res.data.count
        }
      })
    },
    // 切换
    tabClick(key) {
      this.page = 1
      this.load()
    },
    pageChange(pageber) {
      this.page = pageber
      this.load()
    }
  }
}
</script>

<style lang="scss" scoped>
.newsList {
  height: auto;
  overflow: hidden;
  .my-mission-item {
    width: 100%;
    height: auto;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    font-size: 14px;
    // cursor: pointer;
  }

  .wordbrnch-pageination {
    width: 100%;
    height: auto;
    overflow: hidden;
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/workbench/TheBusinessApplication.vue